import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from '../translations/en.json';
import translationHE from '../translations/he.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEN
      },
      he: {
        translation: translationHE
      }
    },
    fallbackLng: localStorage.getItem('language') || 'en',
    debug: false,
    lng: localStorage.getItem('language') || 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;